import http from "../../../http";

export const GET_DASHBOARD_DATA = "dashboard/stats";

export const getDashboardData = (mallId) => {
  return http.get(`${GET_DASHBOARD_DATA}/${mallId}`);
};
